import { NavLink } from "react-router-dom";

export default function AboutUs() {
  return (
    <div>
        {/* Hero Section with Scroll-over Effect */}
    <section className="relative w-screen h-[40vh] md:h-[50vh] flex items-center justify-center">
      {/* Background Image with fixed scrolling */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{ backgroundImage: "url('/images/AboutUs.jpg')" }}
      ></div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black/40"></div>

      {/* Hero Content */}
      <div className="relative z-10 text-center md:text-left text-white px-6 md:px-16 max-w-4xl">
        <h2 className="text-3xl sm:text-5xl md:text-6xl font-bold font-inter">
          ABOUT US
        </h2>
      </div>
    </section>

      {/* About Us Section */}
      <section className="relative w-screen py-16 md:py-24 bg-white">
        <div className="container mx-auto px-6 lg:px-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Text */}
            <div className="flex flex-col font-inter">
              <h3 className="text-2xl sm:text-3xl font-bold mb-6 text-gray-900">
                About Us
              </h3>
              <p className="text-gray-700 mb-6 text-base sm:text-lg md:text-xl leading-relaxed">
                ABHA Care Pty Ltd believes that everyone is important, no matter
                their abilities. You deserve to live a life of purpose and
                independence. As an NDIS service provider, we focus on giving
                you high-quality and personalised care that values your dignity
                and choices as an individual. We know that your journey is
                uniquely your own, and our team will help you as you step
                towards reaching your goals.
              </p>
              <a
                href="/contact"
                className="text-green-700 font-semibold hover:underline inline-flex items-center"
              >
                Contact Us →
              </a>
            </div>

            {/* Image */}
            <div className="flex justify-center md:justify-end">
              <img
                src="/images/AboutUs2.jpg"
                alt="About Us"
                className="rounded-3xl shadow-lg object-cover w-full max-w-md md:max-w-lg"
              />
            </div>
          </div>
        </div>
      </section>

{/* Mission & Vision Section */}
{/* Mission & Vision Section with Background Image and Parallax Scroll */}
<section className="relative w-screen py-16 md:py-24 text-white">
  {/* Background Image */}
  <div
    className="absolute inset-0 bg-cover bg-center bg-fixed rounded-none md:rounded-tr-[50px] lg:rounded-tr-[80px]"
    style={{ backgroundImage: "url('/images/MissionVision.jpg')" }} // Replace with your actual background
  ></div>

  {/* Dark Overlay */}
  <div className="absolute inset-0 bg-[#588157de] bg-opacity-60 rounded-none md:rounded-tr-[50px] lg:rounded-tr-[80px]"></div>

  {/* Content */}
  <div className="relative z-10 container mx-auto px-6 lg:px-20">
    <h3 className="text-2xl sm:text-3xl font-bold text-center mb-12">
      Our Mission and Vision
    </h3>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
      {/* Mission */}
      <div className="flex flex-col items-center text-center">
        <img
          src="/images/Mission.jpg" // Replace with cropped image path
          alt="Our Mission"
          className="rounded-xl mb-6 w-full h-auto max-w-md object-cover shadow-lg"
        />
        <h4 className="text-xl font-semibold mb-4">Our Mission</h4>
        <p className="text-white/90 text-base md:text-lg leading-relaxed">
          Our mission is to deliver high-quality, person-centred NDIS care that
          cares for your well-being and helps you live a dignified and
          independent life. We aim to change your life through comprehensive
          support that allows you to lead a fulfilling life. We are committed to
          making a positive difference by empowering you to participate in the
          community. Through this, we bring opportunities for you to reach your
          personal goals.
        </p>
      </div>

      {/* Vision */}
      <div className="flex flex-col items-center text-center">
        <img
          src="/images/Vision.jpg" // Replace with cropped image path
          alt="Our Vision"
          className="rounded-xl mb-6 w-full h-auto max-w-md object-cover shadow-lg"
        />
        <h4 className="text-xl font-semibold mb-4">Our Vision</h4>
        <p className="text-white/90 text-base md:text-lg leading-relaxed">
          Our vision is to be a leading NDIS disability care services provider
          known for our commitment to quality care and innovation. We aim to
          create a place where people with disabilities enjoy equal
          opportunities and are fully included in their community. For ABHA
          Care, diversity and inclusivity should be embraced and supported so
          that everyone can have the chance to thrive.
        </p>
      </div>
    </div>
  </div>
</section>

      {/* Values / Mission / Vision Section */}
      <section className="bg-gray-100 py-12 sm:py-16 lg:py-20">
  <div className="container mx-auto px-4 sm:px-6 md:px-12 max-w-7xl">
    {/* Header */}
    <div className="text-left mb-8 sm:mb-12">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
        Our Values
      </h2>
      <p className="text-gray-700 mt-2 text-sm sm:text-base md:text-lg max-w-3xl">
        Our values reflect our dedication to the care we provide. These values are:
      </p>
    </div>

    {/* Values Grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
      {/* Value 1 */}
      <div className="flex items-start gap-3 sm:gap-4">
        <img src="/images/leaf.jpg" alt="Respect" className="w-10 h-10 sm:w-11 sm:h-11 mt-0" />
        <div>
          <h4 className="text-base sm:text-lg font-semibold text-gray-900 text-[##3f4f2b]">Respect</h4>
          <p className="text-gray-700 mt-1 text-xs sm:text-sm md:text-base text-[##3f4f2b]">
            We value and accept everyone for who they are. Every voice is heard, and each choice is respected. We cherish relationships and build and nurture it through trust and understanding.
          </p>
        </div>
      </div>

      {/* Value 2 */}
      <div className="flex items-start gap-3 sm:gap-4">
        <img src="/images/leaf.jpg" alt="Compassion and Empathy" className="w-10 h-10 sm:w-11 sm:h-11 mt-0" />
        <div>
          <h4 className="text-base sm:text-lg font-semibold text-gray-900 text-[##3f4f2b]">Compassion and Empathy</h4>
          <p className="text-gray-700 mt-1 text-xs sm:text-sm md:text-base text-[##3f4f2b]">
            Your emotional and practical needs are also important for us, too. It gives the opportunity to understand how we can provide you with the support you need.
          </p>
        </div>
      </div>

      {/* Value 3 */}
      <div className="flex items-start gap-3 sm:gap-4">
        <img src="/images/leaf.jpg" alt="Empowerment" className="w-10 h-10 sm:w-11 sm:h-11 mt-0" />
        <div>
          <h4 className="text-base sm:text-lg font-semibold text-gray-900 text-[##3f4f2b]">Empowerment</h4>
          <p className="text-gray-700 mt-1 text-xs sm:text-sm md:text-base text-[##3f4f2b]">
            We believe that helping you take charge of your own life means guiding you to make informed decisions and build and develop new skills and confidence.
          </p>
        </div>
      </div>

      {/* Value 4 */}
      <div className="flex items-start gap-3 sm:gap-4">
        <img src="/images/leaf.jpg" alt="Integrity" className="w-10 h-10 sm:w-11 sm:h-11 mt-0" />
        <div>
          <h4 className="text-base sm:text-lg font-semibold text-gray-900 text-[##3f4f2b]">Integrity</h4>
          <p className="text-gray-700 mt-1 text-xs sm:text-sm md:text-base text-[##3f4f2b]">
            We maintain the highest standards of NDIS care by always upholding ethical practices.
          </p>
        </div>
      </div>

      {/* Value 5 */}
      <div className="flex items-start gap-3 sm:gap-4">
        <img src="/images/leaf.jpg" alt="Inclusivity" className="w-10 h-10 sm:w-11 sm:h-11 mt-0" />
        <div>
          <h4 className="text-base sm:text-lg font-semibold text-gray-900 text-[##3f4f2b]">Inclusivity</h4>
          <p className="text-gray-700 mt-1 text-xs sm:text-sm md:text-base text-[##3f4f2b]">
            ABHA Care fosters an inclusive community where everyone is treated equally and given the best access and support to our services.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

{/* Our Team */}
 <section className="relative w-screen h-[40vh] md:h-[50vh] flex items-center justify-center">
      {/* Background Image with fixed scrolling */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{ backgroundImage: "url('/images/OurTeam.jpg')" }}
      ></div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black/40"></div>

      {/* Hero Content */}
      <div className="relative z-10 text-center md:text-left text-white px-6 mt-0 md:px-16 max-w-4xl">
        <h2 className="text-xl sm:text-2xl md:text-4xl font-bold font-inter text-center">
          Our Team
        </h2>
        <p className="text-base sm:text-small md:text-lg font-inter text-center mt-10">Meet our amazing NDIS disability assistance partners, who include registered nurses, 
          occupational therapy and physiotherapy support workers, and other specialists.</p>
      </div>
    </section>

    {/*Info Section */}
    <section className="bg-[#3f4f2b] text-white py-40">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-10 text-sm">
        {/* Logo + Location */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left space-y-4">
          <img src="/images/Logo-inverted.svg" alt="ABHA CARE Logo" className="h-16 mx-auto md:mx-0" />
          <p className="font-semibold">New South Wales, Australia</p>
        </div>
    
        {/* Site Links */}
        <div>
          <h4 className="font-bold mb-4 text-lg">Site</h4>
          <ul className="space-y-2 text-lg">
            <li><NavLink to="/" className="hover:underline">Home</NavLink></li>
            <li><NavLink to="/about" className="hover:underline">About Us</NavLink></li>
            <li><NavLink to="/services" className="hover:underline">Services</NavLink></li>
            <li><NavLink to="/faq" className="hover:underline">FAQ</NavLink></li>
            <li><NavLink to="/contact" className="hover:underline">Contact Us</NavLink></li>
          </ul>
        </div>
    
        {/* Location + Hours */}
        <div>
          <h4 className="font-bold mb-4 text-lg">Location</h4>
          <p className="text-lg">Abha Care Pty Ltd<br />
            <br /></p>
    
          <h4 className="font-bold mt-6 mb-2 text-lg">Office Hours</h4>
          <p className="text-lg">
                      Monday - Friday: 9:00AM - 5:00PM<br />
                      Saturday & Sunday: Closed</p>
        </div>
    
        {/* Contact Info */}
        <div>
          <h4 className="font-bold mb-4 text-lg">Contact</h4>
          <p className="text-lg">Phone: 02 8395 2893<br /></p>
          <p className="text-lg ml-14">1300 157 211<br /></p>
          <p className="mt-2 text-lg">
            <a href="mailto:info@abhacare.com.au" className="hover:underline text-lg">
              info@abhacare.com.au
            </a>
          </p>
        </div>
      </div>
    </section>

    </div>
  );
}
